import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { PagesService } from '@services/pages.service';
import { SharedService } from '@services/shared.service';
import { AuthService } from 'src/app/Auth/AuthService';
import { environment } from '@env';

@Component({
  selector: 'app-forgotpassword',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink, CommonModule],
  templateUrl: './sendOTP.component.html',
  // styleUrl: './sendOTP.component.scss',
  styleUrls: ['./sendOTP.component.scss', '../../../../auth.scss'],

})
export class SENDOTPComponent implements OnInit {
  baseUrl = environment.baseUrl;
  ForgetPasswordForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private route: Router,
    private authService: AuthService,
    private pageService: PagesService,
    private sharedService: SharedService,
    private activaterouter: ActivatedRoute
  ) { }
  planData: any = null;
  ngOnInit(): void {
    this.ForgetPasswordForm = this.fb.group({
      PhoneNumber: ['', [Validators.required]],
    });
    this.activaterouter.queryParams.subscribe(params => {
      const token = params['token'];
      if (token) {
        try {
          const decoded = atob(token);
          this.planData = JSON.parse(decoded);
        } catch (err) {
          console.error('Invalid token format', err);
          this.route.navigate(['/pricing']);
        }
      } else {
        this.route.navigate(['/pricing']);
      }
    });
  }

  handleOpt() {
    this.sharedService.showLoader();
    this.pageService.update('SEND_OPT', null).subscribe({
      next: (response: any) => {
        localStorage.setItem('optmail', response.email);
        JSON.stringify(
          localStorage.setItem('otp_expiry', response.otp_expiry_timestamp)
        );
        this.sharedService.createNotification(
          'success',
          'Your OTP has been Sent successfully.'
        );
        this.sharedService.hideLoader();
        const token = btoa(JSON.stringify(this.planData));
        this.route.navigate(['/auth/verify-otp'], { queryParams: { token } });

      },
    });
  }
}
